"use strict";

exports.__esModule = true;
exports.Months = void 0;
exports.areSameDay = areSameDay;
exports.areSameMonth = areSameMonth;
exports.getDefaultMaxDate = getDefaultMaxDate;
exports.getDefaultMinDate = getDefaultMinDate;
exports.isToday = isToday;
var Months = {
  JANUARY: 0,
  FEBRUARY: 1,
  MARCH: 2,
  APRIL: 3,
  MAY: 4,
  JUNE: 5,
  JULY: 6,
  AUGUST: 7,
  SEPTEMBER: 8,
  OCTOBER: 9,
  NOVEMBER: 10,
  DECEMBER: 11
}; // Default is 10 years in the future from today's date

exports.Months = Months;

function getDefaultMaxDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear() + 10);
  date.setMonth(Months.DECEMBER, 31);
  return date;
} // Default is 20 years in the past from today's date


function getDefaultMinDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 20);
  date.setMonth(Months.JANUARY, 1);
  return date;
}

function areSameDay(date1, date2) {
  return areSameMonth(date1, date2) && date1.getDate() === date2.getDate();
}

function areSameMonth(date1, date2) {
  return date1 != null && date2 != null && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
}

function isToday(date) {
  return areSameDay(date, new Date());
}